import React, { useEffect, useState } from "react";
import {
  Row,
  Space,
  Form,
  Input,
  Button,
  Select,
  message,
  ConfigProvider,
} from "antd";
import { postAPI, getAPI } from "../../../config/api/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import { setDeviceAdded } from "../../../redux/feature/device";

const { Option } = Select;

const RegisterDevice = () => {
  
  const token = useSelector((state) => state.authenticate.userToken);
  const [data, setData] = useState([]);
  const [isDeviceAdded, setIsDeviceAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getUserId, setGetUserid] = useState(null);
  const [msg, setMsg] = useState("");
  const [userOrganisation, setUserOrganisation] = useState();

  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const userId = useSelector((state) => state.authenticate.userId);
  const organisationName = useSelector((state) => state.authenticate.organisationName)
  const userOrganisationName = userOrganisation.organisationName ? userOrganisation.organisationName : ""
  // const userOrganisationName = userOrganisation?.organisationName || "";
  console.log("organisationName: ", organisationName)
  console.log("userOrganisation: ", userOrganisation)

  const check = useSelector((state) => 
  {console.log("state: ", state) // to log what state returns from the redux store
  });

  console.log("ACCOUNT ID", userId);
  // useEffect(() => {
  //   getAPI("get-organisations", token)
  //     .then((response) => {
  //       console.log("RES", response);
  //       const { data } = response.data;
  //       setData(data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // }, []);

  useEffect(() => {
    if (userId) {
      getAPI(`/get-organisation-by-user/${userId}`)
        .then((response) => {
          console.log("RES", response);
          const { data } = response.data;
          setUserOrganisation(data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userId]);

  useEffect(() => {
    if (userId === null || userId === 0) return;
    setGetUserid(userId);
  }, [userId]);

  const addDevice = async (values) => {
    console.log(values)
    const formValues = {
      ...values,
      userId: parseInt(getUserId),
    };
    console.log(values)

    setIsDeviceAdded(false);
    try {
      setLoading(true);

      const registerDevice = await postAPI(
        `/register-device/${parseInt(getUserId)}`,
        formValues
      );

      const { data, success } = registerDevice.data;
      if (success) {
        message.success("Device Added Successfully");
        dispatch(setDeviceAdded(data));
        setIsDeviceAdded(success);
        //setMsg(message);
        setLoading(false);
        form.resetFields();
      }
    } catch (err) {
      if (err) {
        setIsDeviceAdded(false);
        setLoading(false);
        setMsg(err.response?.data?.message);
        message.error(err.response?.data?.message);
        console.log(err);
        form.resetFields();
      }
    }
  };

  return (
    <Row
      style={{
        padding: 0,
        margin: 0,
        height: "auto",
        overflowY: "auto",
        maxHeight: "55vh",
      }}
      gutter={0}
    >
      <div className="row-nibss">
        {
          // this.routeParams
          <div className="device-form">
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            ></Space>

            <Form
              form={form}
              onFinish={addDevice}
              // onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col"
            >
            <Form.Item
              className="username input-device"
              label={(
                <span>
                  Device Name
                  <span style={{ fontSize: 'smaller', color: 'green' }}> {/* Inline CSS */}
                    (Device Name & Device Model inputted will be captured on the certificate)
                  </span>
                </span>
              )}
              name="deviceName"
              rules={[
                {
                  required: true,
                  message: "Please input your name!",
                },
              ]}
            >
              <Input placeholder="Enter your Device Name" />
            </Form.Item>

              <Form.Item
                className="username input-device"
                label="Device Type"
                name="deviceType"
                rules={[
                  {
                    required: true,
                    message: "Please select your device type!",
                  },
                ]}
              >
                <Select
                  placeholder="Select a Device Type"
                  style={{ fontWeight: "600", width: "100%" }}
                >
                  <Option value="single">Single</Option>
                  <Option value="multiple">Multiple</Option>
                </Select>
              </Form.Item>
              <Form.Item
                className="username input-device"
                label="Device Model"
                name="deviceModel"
                rules={[
                  {
                    required: true,
                    message: "Please input Device Model",
                  },
                ]}
              >
                <Input placeholder="Device Model" />
              </Form.Item>
              <Form.Item
                className="username input-device"
                label="Organisation Name"
                name="organisationName"
                // initialValue={userOrganisationName}
                rules={[
                  {
                    required: true,
                    message: "Please input your Organisation Name",
                  },
                ]}
              > 
                <Input placeholder="Organisation Name" disabled />
                {/* <Select
                  placeholder="Select your Organisation"
                  style={{ fontWeight: "600", width: "100%" }}
                >
                  {data.map((name) => (
                    <Option value={name.organisationName
                    }>{name.organisationName
                    }</Option>
                  ))}
                </Select> */}
              </Form.Item>
              {/* <Form.Item
                className="username input-device"
                label="Biometric Scanner"
                name="biometricScanner"
                rules={[
                  {
                    required: true,
                    message: "Please input organisation Name",
                  },
                ]}
              >
                <Input placeholder="Biometric Scanner" />
              </Form.Item> */}
              <Form.Item
                name="userId"
                style={{ display: "none" }}
                value={parseInt(getUserId)}
                initialValue={parseInt(getUserId)}
              >
                <Input defaultValue={parseInt(getUserId)} />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="nibss-form-btn reg-btn"
                  loading={loading}
                >
                  Add Device
                </Button>
              </Form.Item>
            </Form>
          </div>
        }
      </div>
    </Row>
  );
};

export default RegisterDevice;
